import { debounce } from "lodash";

// Shared trailing autosave debounce for the test-creation summary. Kept in one
// module so every authoritative save (the title save in ExerciseSheetTitle, finish in Summary)
// can cancel a still-pending autosave before its stale closure overwrites newer data (e.g. the
// edited title) or creates a duplicate test.
export const updateTestInServerDebounced = debounce(
    (functionToCall: () => void) => {
        functionToCall();
    },
    1000,
    {
        leading: false,
        trailing: true,
    }
);
